import { jwtDecode } from "jwt-decode";

export const decodeToken = (token) => {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

// Returns true if the permissions array includes the given permission string.
export const hasPermission = (permissions = [], permission) =>
  permissions.includes(permission);
